import { Autocomplete, Box, CircularProgress, TextField, useTheme } from '@mui/material'
import { useUserItems } from 'api/aws/users/useUserItems'
import { useEffect, useState } from 'react'
import { useUsersById } from '../../api/customHooks/useUsersById'
import { renderUserOption } from '../Team/renderOptions'

const AssignOwnerAutocomplete = ({ userId, label, onChange, context, onBlur, multiple = false }) => {
  const theme = useTheme()
  const [inputValue, setInputValue] = useState('')

  // Ensure userId is treated as an array
  const ownerIds = Array.isArray(userId) ? userId : userId ? [userId] : []

  // Fetch all users for dropdown options
  const { data: allUsers, isLoading: isUsersLoading } = useUserItems()
  const owner = allUsers?.find(u => u?.user_uuid === ownerIds?.[0])
  // Fetch selected owner(s)
  const { users: fetchedUsers, isUsersByIdLoading } = useUsersById(ownerIds)

  // Maintain selected user state
  const [selectedUser, setSelectedUser] = useState(multiple ? [] : null)

  // Sync selected user state when new users are fetched
  useEffect(() => {
    if (!isUsersByIdLoading && !isUsersLoading && fetchedUsers.length > 0) {
      setSelectedUser(multiple ? fetchedUsers : fetchedUsers[0] || null)
    }
  }, [fetchedUsers, isUsersLoading, isUsersByIdLoading, multiple])

  // Handle user selection
  const handleSelectUser = (_, newValue) => {
    console.log('[handleSelectUser] newValue', newValue)
    if (multiple) {
      setSelectedUser(newValue)
      const newOwnerIds = newValue.map(user => user.id)
      onChange(context, newOwnerIds)
      if (onBlur) onBlur(context, newOwnerIds)
    } else {
      setSelectedUser(newValue)
      const emitId = newValue ? (newValue.user_uuid ?? newValue.id) : null
      onChange(context, emitId)
      if (onBlur) onBlur(context, emitId)
    }
  }

  if (isUsersLoading || isUsersByIdLoading) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Autocomplete
      multiple={multiple}
      id="assign-owner-autocomplete"
      options={allUsers || []} // 🔥 Use ALL users instead of only fetchedUsers
      getOptionLabel={option =>
        option.real_name ||
        `${option.firstName || option.first_name} ${option.lastName || option.last_name} (${option.email})`
      }
      // value={selectedUser || owner}
      value={multiple ? selectedUser || [] : selectedUser ?? null}
      onChange={handleSelectUser}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      isOptionEqualToValue={(option, value) => !!option && !!value && option.id === value.id}
      filterOptions={(options, { inputValue }) =>
        options.filter(option =>
          `${option.firstName || option.first_name} ${option.lastName || option.last_name}`
            .toLowerCase()
            .includes(inputValue.toLowerCase())
        )
      }
      renderOption={(props, option, state) => renderUserOption(props, option, state, theme)}
      renderInput={params => <TextField {...params} label={label} />}
      fullWidth
    />
  )
}

export default AssignOwnerAutocomplete
